import { ShoppingBag, ExternalLink } from 'lucide-react';

// Product image from Worthy Vets
const PRODUCT_IMAGE = "https://customer-assets.emergentagent.com/job_vets-intake-demo/artifacts/kcpad1j7_unnamed.png";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_vets-intake-demo/artifacts/e4mtecfo_Untitled%20design%20%2892%29.png";
const SQUARE_SHOP_URL = "https://worthy-vets-service-group.square.site/s/shop";

export const ShopPage = () => {
  const openShop = () => {
    window.open(SQUARE_SHOP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="page-transition" data-testid="shop-page">
      {/* Hero Section */}
      <section className="bg-wv-blue py-12" data-testid="shop-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-wv-red text-lg font-semibold mb-4 tracking-wide uppercase">
              Shop
            </p>
            <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6 uppercase tracking-wide">
              Show Your<br />Veteran Pride
            </h1>
            <p className="text-xl text-white/80 leading-relaxed">
              Support our mission while proudly displaying your veteran pride with 
              exclusive Worthy Vets merchandise.
            </p>
          </div>
        </div>
      </section>

      {/* Product Image - Centered */}
      <section className="py-10 bg-paper-white" data-testid="product-gallery">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center">
            <button 
              onClick={openShop}
              className="rounded-lg overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-shadow focus:outline-none focus:ring-4 focus:ring-wv-red"
              aria-label="View products in our Square store"
            >
              <img 
                src={PRODUCT_IMAGE} 
                alt="Worthy Vets WORTHY branded t-shirts in black, green, camo, and white colors"
                className="w-full h-auto"
                loading="lazy"
              />
            </button>
          </div>
          <p className="text-center text-gray-600 mt-4">Click image to shop</p>
        </div>
      </section>

      {/* Shop Section - Clickable to Square */}
      <section className="py-8 bg-white" data-testid="square-shop-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Instructions */}
          <div className="text-center mb-6">
            <h2 className="font-heading text-3xl font-bold text-wv-blue mb-2">
              Browse Our Products
            </h2>
            <p className="text-gray-600">
              Click anywhere below to open our store and add items to your cart.
            </p>
          </div>

          {/* Shop Preview - Direct link */}
          <a
            href={SQUARE_SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-white rounded-lg shadow-lg border-2 border-gray-100 overflow-hidden hover:border-wv-red transition-colors"
            aria-label="Open Worthy Vets store to browse and purchase products"
          >
            <iframe
              src="https://worthy-vets-service-group.square.site/s/shop"
              title="Worthy Vets Shop Preview"
              className="w-full pointer-events-none"
              style={{ height: '600px', border: 'none' }}
              scrolling="no"
              loading="lazy"
              aria-hidden="true"
              tabIndex={-1}
            />
          </a>
          
          {/* Direct Shop Button */}
          <div className="text-center mt-8">
            <button
              onClick={openShop}
              className="bg-wv-red text-white font-bold text-xl py-5 px-12 rounded-md hover:bg-red-700 transition-colors inline-flex items-center gap-3 shadow-lg focus:outline-none focus:ring-4 focus:ring-wv-blue"
              data-testid="shop-btn"
            >
              <ShoppingBag className="w-6 h-6" aria-hidden="true" />
              Shop Now & Add to Cart
              <ExternalLink className="w-5 h-5" aria-hidden="true" />
            </button>
            <p className="text-gray-500 mt-3 text-sm">
              Opens our secure Square store in a new tab
            </p>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-12 bg-wv-blue" data-testid="shop-info">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6">
            Supporting Veterans Through Every Purchase
          </h2>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            A portion of every purchase goes toward supporting our mission of helping 
            veterans navigate the VA claims process.
          </p>
        </div>
      </section>
    </div>
  );
};
